let baseUrl = "http://localhost:5000/api/v1";
let mediaUrl = 'http://localhost:5000/';

// let baseUrl = "https://api.getveriscan.dev/api/v1";
// let mediaUrl = "https://api.getveriscan.dev/";

// let baseUrl = 'http://localhost:5000/api/v1';
// let mediaUrl = 'http://localhost:5000/';

if (window.location.host === "admin.getveriscan.dev" ||
  window.location.host === "client.getveriscan.dev") {
  baseUrl = "https://api.getveriscan.dev/api/v1";
  mediaUrl = "https://api.getveriscan.dev/";
} else if (
  window.location.host === "admin.getveriscan.com" ||
  window.location.host === "client.getveriscan.com"
) {
  baseUrl = "https://api.getveriscan.com/api/v1";
  mediaUrl = "https://api.getveriscan.com/";
}

// Helper: if path is already a full URL (R2/CDN), return as-is; otherwise prepend mediaUrl
function getMediaUrl(path) {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return mediaUrl + path;
}

module.exports = { baseUrl, mediaUrl, getMediaUrl };
